import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TelegramRoutingModule} from './telegram-routing.module';
import {ListPageComponent} from './list-page/list-page.component';
import {UserListComponent} from './user-list/user-list.component';
import {ScrappedUserListComponent} from './scrapped-user-list/scrapped-user-list.component';
import {ChannelAddUserHistoryListComponent} from './channel-add-user-history-list/channel-add-user-history-list.component';
import {CreatePageComponent} from './create-page/create-page.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {EditpagesComponent} from './editpages/editpages.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserAddComponent } from './user-add/user-add.component';
import {OurchannelComponent} from './ourchannel/ourchannel.component';
import {ChannelmessageComponent} from './channelmessage/channelmessage.component';
import {ViewpagesComponent} from './viewpages/viewpages.component';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
    declarations: [ListPageComponent, UserListComponent, UserAddComponent, UserEditComponent, CreatePageComponent, EditpagesComponent,
        OurchannelComponent, ChannelmessageComponent, ViewpagesComponent, ScrappedUserListComponent, ChannelAddUserHistoryListComponent],
    imports: [
        CommonModule,
        TelegramRoutingModule,
        NgbModule,
        ReactiveFormsModule,
        SharedModule,
        DragDropModule,
        FormsModule,
        NgxPaginationModule,

    ]
})
export class TelegramModule {
}
